module.exports = __webpack_public_path__ + "static/media/review-5-stars.d0ca59b5.svg";